export class RateioContaModel {
    constructor(init?: Partial<RateioContaModel>) {
        Object.assign(this, init);
    }

    qtdPessoas: number;
    totalPorPessoa: number;
    subtotal: number;
    opcional: number;
    valorPago: number;
    restantePagar: number;
    desconto: number;
    incluirOpcional: boolean = true;

    /**
     * @returns this.subtotal / this.qtdPessoas
     */
    obterTotalPorPessoa(): number {
        let total = (this.obterRestantePagar() ?? 0) / (this.qtdPessoas ?? 0);

        if (this.qtdPessoas === 1) {
            total = this.obterRestantePagar() ?? 0;
        } else {
            total = parseFloat(total.toFixed(1));
        }

        return total;
    }

    /**
     * 
     * @returns this.subtotal - this.valorPago
     */
    obterRestantePagar(): number {
        let total = (this.subtotal ?? 0) - (this.valorPago ?? 0) - (this.desconto ?? 0);

        total += this.incluirOpcional ? this.opcional : 0;

        return total;
    }
}
